import './datenschutz.css';
import Footer from '../footer/Footer';
import logo from '../../assets/Logo.webp';

const Datenschutz = ({ onShowImpressum }) => {
    return (
        <div className='datenschutz'>
            <div className="datenschutzContainer">
                <a className='logoClass'  href='/'><img src={logo} alt="logo" /></a>
                
                <h1>Datenschutzerklärung</h1>
                
                <p>Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Auf dieser Website werden so wenige Daten wie möglich verarbeitet. Im Folgenden informieren wir Sie gemäß Art. 12 ff. DSGVO über Art, Umfang und Zweck der Datenverarbeitung.</p>
                
                <h2>1. Verantwortliche Stelle</h2>
                
                <div className="contactInfo">
                    <p>Eva-Christin List</p>
                    <p>Am Graskamp 23</p>
                    <p>48531 Nordhorn</p>
                    <p>Telefon: 05921 7058150</p>
                    <p>E-Mail: kontakt(at)evalist.de</p>
                </div>
                
                <h2>2. Allgemeine Nutzung der Website</h2>
                <p>Beim Besuch dieser Website werden keine personenbezogenen Daten gespeichert.</p>
                <p>Es werden weder IP-Adressen protokolliert noch Cookies gesetzt.</p>
                
                <h2>3. Nutzung des Mental-Media-Score®</h2>
                <p>Das Test-Tool Mental-Media-Score® auf dieser Website dient ausschließlich der Analyse von Texteingaben in Echtzeit.</p>
                <ul>
                    <li>Die eingegebenen Texte werden nur für den Moment der Analyse verarbeitet.</li>
                    <li>Es erfolgt keine Speicherung, keine Protokollierung und keine Weitergabe der eingegebenen Inhalte.</li>
                </ul>
                
                <h2>4. Kontaktaufnahme</h2>
                <p>Wenn Sie uns per E-Mail oder Telefon kontaktieren, werden die von Ihnen übermittelten Angaben ausschließlich zur Bearbeitung Ihrer Anfrage genutzt.</p>
                <p>Eine Weitergabe an Dritte erfolgt nicht.</p>
                
                <h2>5. Ihre Rechte</h2>
                <p>Sie haben nach DSGVO folgende Rechte:</p>
                <ul>
                    <li>Auskunft über die bei uns verarbeiteten Daten (Art. 15 DSGVO)</li>
                    <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
                    <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
                    <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
                    <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
                    <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
                </ul>
                <p>Zur Wahrnehmung Ihrer Rechte genügt eine formlose Mitteilung an die oben genannten Kontaktdaten.</p>
                
                <h2>6. Beschwerderecht</h2>
                <p>Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer Daten gegen geltendes Datenschutzrecht verstößt.</p>
            </div>
            
            <Footer 
                currentPage="datenschutz"
                onShowImpressum={onShowImpressum} // Direct navigation to Impressum
                onShowDatenschutz={() => {}} // Empty function for current page
            />
        </div>
    )
}

export default Datenschutz;